/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Help_SubtitleInputs */



/**
* | output |
* | --- |
* | "Answers to the questions partners ask most." |
*
* @param {Partner_Help_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_help_subtitle = /** @type {((inputs?: Partner_Help_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Help_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Antworten auf die häufigsten Fragen von Partnern.")
	return /** @type {LocalizedString} */ ("Answers to the questions partners ask most.")
});